module.exports = __webpack_public_path__ + "img/6.93a5c38e.png";